export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const EMAIL_ID = "email";
export const MOBILE_NO = "phone";
export const EMP_ID = "employmentCode";
export const LOGIN_ID = "loginId";
export const TEMP_PASSWORD = "password";
export const FORCE_PASSWORD = "forcePasswordChange";
export const ADDRESS = "address";
export const STATE = "stateId";
export const COUNTRY = "countryId";
export const CITY = "cityId";
export const ZIPCODE = "zipcode";
